import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';
import { ulid } from 'ulidx';
import { ROLES } from '@/constants/global';
import { ParsedPhoneNumber, UserAllowed } from './utilities.type';

const VALID_COUNTRIES: CountryCode[] = ['US', 'CA', 'MX', 'HN', 'PR'];

export const parsePhoneNumber = (
	phone: string,
	areaCodes: CountryCode[] = VALID_COUNTRIES
): ParsedPhoneNumber | null => {
	const parsedNumber = parsePhoneNumberFromString(phone);

	if (parsedNumber?.isValid() && parsedNumber.country && areaCodes.includes(parsedNumber.country)) {
		return {
			prefix: `+${parsedNumber.countryCallingCode}`,
			phone: parsedNumber.nationalNumber,
			shortName: parsedNumber.country.toLowerCase(),
		};
	}
	return null;
};

export const convertMegaBytes = (megaBytes: number): string => {
	const gigaBytes = megaBytes / 1024;
	const teraBytes = gigaBytes / 1024;
	if (teraBytes >= 1) {
		return `${teraBytes.toFixed(2)} TB`;
	} else if (gigaBytes >= 1) {
		return `${gigaBytes.toFixed(2)} GB`;
	} else {
		return `${megaBytes.toFixed(0)} MB`;
	}
};

export const getUniqueSessionId = (): string => {
	let sessionId = localStorage.getItem('sessionId');
	if (!sessionId) {
		sessionId = ulid();
		localStorage.setItem('sessionId', sessionId);
	}
	return sessionId;
};

export const isUserAllowed = ({
	userRoles,
	allowedRoles,
	impersonatorRoles = [],
	isImpersonating = false,
	adminRoles = [ROLES.MASTER, ROLES.SERVICE_PROVIDER, ROLES.ACCOUNT_MANAGER],
}: UserAllowed): boolean => {
	if (!isImpersonating) {
		return allowedRoles.some((role) => userRoles.includes(role));
	}
	if (adminRoles.some((role) => impersonatorRoles.includes(role))) {
		return allowedRoles.some((role) => impersonatorRoles.includes(role));
	}
	return false;
};

export const formatEmailTypeLabel = (emailType: string): string => {
	const withoutPrefix = emailType.includes('.') ? emailType.split('.').pop() || emailType : emailType;
	return withoutPrefix.replace(/_/g, ' ').toUpperCase();
};
